import { useState, useEffect } from 'react';
import { authentication } from '@microsoft/teams-js';
import { GetCaseDataRequestBody, Product } from 'types';
import getCaseData from '../utils/requests';
import mockup from '../mockups/example_diag_response.json';
import { IS_IN_DEV } from '../constants';

export default function useCaseData() {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<{ status: number } | null>(null);

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const diagnosticId = params.get('diagnostic_id');
    const caseId = params.get('case_id');
    const env = params.get('env');
    const product = params.get('product') as Product;
    const hasNeededParams = (diagnosticId && env) || (caseId && product && env);

    if (!hasNeededParams
    ) {
      setError({ status: 400 });
      return;
    }

    const handleDataReq = async (token: string) => {
      try {
        let requestBody: GetCaseDataRequestBody;
        if (diagnosticId) {
          requestBody = {
            diag_id: diagnosticId,
          };
        } else {
          requestBody = {
            case_id: caseId,
            product,
          };
        }

        const res = await getCaseData(token, requestBody, env);
        if (res.ok) {
          const result = await res.json();
          setData(result);
        } else {
          setError({ status: res.status });
        }
      } catch (err) {
        console.error(err);
        setError({ status: 500 });
      }
    };

    const fetchCaseData = async () => {
      try {
        authentication.getAuthToken({
          successCallback: async (token) => {
            await handleDataReq(token);
          },
          failureCallback: (MsError) => {
            console.error(MsError);
            setError({ status: 401 });
          },
        });
      } catch (err) {
        console.error(err);
        setError({ status: 500 });
      }
    };

    const checkDevMode = async () => {
      if (!data && IS_IN_DEV) {
        const devToken = process.env.REACT_APP_MICROSOFT_DEV_TOKEN;
        if (devToken) {
          await handleDataReq(devToken);
        } else {
          setData(mockup);
        }
      }
    };

    fetchCaseData();
    checkDevMode();
  }, []);

  return { data, error };
}
